import { combineReducers } from 'redux';

import {
    BonusSettlementsOverviewReducerState,
    bonusSettlementsOverviewReducer,
} from '../overview/store/bonus-settlements-overview-reducer';
import {
    BonusSettlementsPoolDetailState,
    bonusSettlementsPoolDetailReducer,
} from '../details/pool-details/store/bonus-settlements-pool-detail-reducer';
import {
    BonusSettlementsState,
    bonusSettlementsDetailReducer,
} from '../details/store/bonus-settlements-detail-reducer';

export interface BonusSettlementsReducerState {
    overview: BonusSettlementsOverviewReducerState;
    detail: BonusSettlementsState;
    poolDetail: BonusSettlementsPoolDetailState;
}

export const bonusSettlementsReducer = combineReducers<BonusSettlementsReducerState>({
    overview: bonusSettlementsOverviewReducer,
    detail: bonusSettlementsDetailReducer,
    poolDetail: bonusSettlementsPoolDetailReducer,
});
